"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const md_1 = require("react-icons/md");
function TableHeader(_a) {
    var { children, className = '', isSorted, isSortedDesc } = _a, tableHeaderProps = __rest(_a, ["children", "className", "isSorted", "isSortedDesc"]);
    return ((0, jsx_runtime_1.jsx)("th", Object.assign({}, tableHeaderProps, { className: (0, classnames_1.default)('px-4', 'text-silver-100', 'text-h200', 'font-bold', {
            'bg-silver-5 border-b-2 border-b-blue-80': isSorted,
        }, className) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: children }), (0, jsx_runtime_1.jsx)("span", { children: isSorted ? (isSortedDesc ? ((0, jsx_runtime_1.jsx)(md_1.MdExpandLess, { size: 20 })) : ((0, jsx_runtime_1.jsx)(md_1.MdExpandMore, { size: 20 }))) : ('') })] })) })));
}
exports.TableHeader = TableHeader;
//# sourceMappingURL=TableHeader.js.map